import Main from '../views/index.vue'
import { Route } from 'vue-router'

export default function() {
  return [
    {
      path: '/exam',
      async beforeEnter(to: Route, from: Route, next: () => {}) {
        const body = document.querySelector('body')
        if (body) {
          body.setAttribute('class', 'exam')
        }
        console.log(to, from)
        next()
      },
      component: Main,
      children: [
        // 试题练习
        {
          path: 'practice',
          props: true,
          name: 'ExamPractice',
          component: () => import('../views/my-question/practice/practice.vue'),
          children: [
            // 随机抽题
            {
              path: 'random',
              props: true,
              meta: { needLogin: true },
              name: 'Random',
              component: () => import('../../center/views/my-question/practice/random-question.vue')
            }
          ]
        },
        {
          // 进入模考的中间页
          path: 'mock-exam-info',
          name: 'MockExamInfo',
          meta: { needLogin: true },
          component: () => import('../views/my-question/mock-exam-info/mock-exam-info.vue')
        },
        // 练习解析
        {
          path: 'practice-parsing',
          props: true,
          meta: { needLogin: true },
          name: 'ExamPracticeParsing',
          component: () => import('../views/my-question/practice/practice-parsing.vue')
        },
        // 模拟考试
        {
          path: 'mock-exam',
          props: true,
          meta: { needLogin: true },
          name: 'ExamMockExam',
          component: () => import('../views/my-question/mock-exam/mock-exam.vue')
        },
        // 试卷浏览
        {
          path: 'preview/:token',
          props: true,
          meta: { needLogin: false },
          name: 'Preview',
          component: () => import('../views/my-question/preview/preview.vue')
        },
        // 模拟考试 - 练习模式
        {
          path: 'mock-exam-data',
          props: true,
          meta: { needLogin: true },
          name: 'ExamMockExamData',
          component: () => import('../views/my-question/practice/examdata-practice.vue')
        },
        // 每日一练中间页面
        {
          path: 'daily-practice-info',
          props: true,
          meta: { needLogin: true },
          name: 'ExamDailyPracticeInfo',
          component: () => import('../views/my-question/daily-info/daily-exam-info.vue')
        },
        // 每日一练
        {
          path: 'daily-practice',
          props: true,
          meta: { needLogin: true },
          name: 'ExamDailyPractice',
          component: () => import('../views/my-question/daily-practice/daily-practice.vue')
        },
        // 易错题
        {
          path: 'error-prone',
          props: true,
          meta: { needLogin: true },
          name: 'ExamErrorProne',
          component: () => import('../views/my-question/error-prone/error-prone.vue')
        },
        // 考试报告
        {
          path: 'examination-report',
          props: true,
          meta: { needLogin: true },
          name: 'ExamExaminationReport',
          component: () => import('../views/my-question/examination-report.vue')
        },
        // 模拟考试解析
        {
          path: 'mock-exam-parsing',
          props: true,
          meta: { needLogin: true },
          name: 'ExamMockExamParsing',
          component: () => import('../views/my-question/mock-exam/mock-exam-parsing.vue')
        }
      ]
    }
  ]
}
